import { render } from "./tabbed_card.vue?vue&type=template&id=554599d0"
import script from "./tabbed_card.vue?vue&type=script&lang=js"
export * from "./tabbed_card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__